import React, { useContext } from "react"
import { Link } from "gatsby"
import Img from "gatsby-image"
import Collapse from '@material-ui/core/Collapse';
import styles from "./line-bonus-card.module.scss"
import {
  Grid,
  Button
} from "@material-ui/core"
import CasinoHelper from "../../services/casino-bonus-helpers"
import GenericHelpers from "../../services/GenericHelpers"
import r from "../../services/Router"
import t from "../../services/GetTranslationValue"

import PlayArrowIcon from "@material-ui/icons/PlayArrow"
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ThemeContext from "../../context/ThemeContext"
import { getMaxBetText } from "../../services/casino-property-renders"
import BlockIcon from '@material-ui/icons/Block';

const LineBonusCard = ({ casino, index, forceSports, locale, isRaffle,
  forceTopBonus, forceSpecificBonusType, showBonusCode, isSelected, promotionalText, buttonName }) => {

  const getBonusToUse = (casino, forceSports, forceSpecificId, showBonusCode) => {
    if (forceSpecificId)
      return CasinoHelper.GetBonusFromCasinoByTypeId(casino, forceSpecificId);

    let firstDepositBonus = forceTopBonus
      ? CasinoHelper.GetTopFirstDepositBonus(casino)
      : CasinoHelper.GetFirstDepositBonus(casino)
    if (showBonusCode) {
      firstDepositBonus = CasinoHelper.GetFirstDepositBonuses(casino).find(x => x.bonusCode && x.bonusCode.length > 2);
    }
    const sportsbookBonus = CasinoHelper.GetSportsbookBonus(casino)
    const noDepositBonus = CasinoHelper.GetNoDepositBonus(casino)
    const cashbackBonus = CasinoHelper.GetCashbackBonus(casino)

    if (forceSports) return sportsbookBonus

    if (firstDepositBonus) return firstDepositBonus

    if (cashbackBonus) return cashbackBonus
  }

  const firstDepositBonus = CasinoHelper.GetTopFirstDepositBonus(casino);

  const [expanded, setExpanded] = React.useState(false);
  const [desktopExpanded, setDesktopExpanded] = React.useState(false);

  const site = useContext(ThemeContext)
  let { translations } = site

  const getBonusCodeLine = (translations, bonus) => {
    return [
      <p className={`${styles.header}`}>
        {bonus ? bonus.bonusCode : null }
      </p>,
      <p> {t.get(translations, "bonus-code")} </p>,
    ]
  }
  const getFreespinsNoDepositLine = (translations, freespinNoDepositBonus) => {
    return [
      <p className={`${styles.header}`}>
        {freespinNoDepositBonus ? freespinNoDepositBonus.freespinsAmount : "-"}
      </p>,
      <p> {t.get(translations, "freespins-no-deposit")} </p>,
    ]
  }

  const getMrGambleRatingLine = (translations, casino) => {
    return [
      <p className={`${styles.header}`}>
        {GenericHelpers.casinoAverageRating(casino)} / 5
      </p>,
      <p> {t.get(translations, "mr-gamble-rating")} </p>
    ]
  }

  const getSportsbookMinimumOddLine = (translations, sportsbookBonus) => {
    return [
      <p className={`${styles.header}`}>
        {sportsbookBonus && sportsbookBonus.minimumOdd
          ? sportsbookBonus.minimumOdd
          : "-"}
      </p>,
      <p> {t.get(translations, "minimum-odd")} </p>,
    ]
  }

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleDesktopExpandClick = () => {
    setDesktopExpanded(!desktopExpanded);
  };

  const bonusList = (casino) => {

    let firstBonus = CasinoHelper.GetFirstDepositBonus(casino);
    let secondBonus = CasinoHelper.GetSecondDepositBonus(casino);
    let thirdBonus = CasinoHelper.GetThirdDepositBonus(casino);
    let fourthBonus = CasinoHelper.GetFourthDepositBonus(casino);
    let fifthBonus = CasinoHelper.GetFifthDepositBonus(casino);
    let sixthBonus = CasinoHelper.GetSixthDepositBonus(casino);
    const bonusArray = [
      firstBonus !== null ? {
        "label": t.get(translations, "First deposit"),
        "value": firstBonus.bonusValue !== null ? firstBonus.bonusValue : "- ",
        "amount": firstBonus.maximumBonusAmount !== null ? firstBonus.maximumBonusAmount : "- ",
        "maxBonusCashout": firstBonus.maxBonusCashout ? firstBonus.maxBonusCashout: "",
        "freeSpin": firstBonus.freespinsAmount !== null ? firstBonus.freespinsAmount : "-"
      } : null,
      secondBonus !== null ? {
        "label": t.get(translations, "Second deposit"),
        "value": secondBonus.bonusValue !== null ? secondBonus.bonusValue : "- ",
        "amount": secondBonus.maximumBonusAmount !== null ? secondBonus.maximumBonusAmount : "- ",
        "maxBonusCashout": secondBonus.maxBonusCashout ? secondBonus.maxBonusCashout: "",
        "freeSpin": secondBonus.freespinsAmount !== null ? secondBonus.freespinsAmount : "-"
      } : null,
      thirdBonus !== null ? {
        "label": t.get(translations, "Third deposit"),
        "value": thirdBonus.bonusValue !== null ? thirdBonus.bonusValue : "- ",
        "amount": thirdBonus.maximumBonusAmount !== null ? thirdBonus.maximumBonusAmount : "- ",
        "maxBonusCashout": thirdBonus.maxBonusCashout ? thirdBonus.maxBonusCashout: "",
        "freeSpin": thirdBonus.freespinsAmount !== null ? thirdBonus.freespinsAmount : "-"
      } : null,
      fourthBonus !== null ? {
        "label": t.get(translations, "Fourth deposit"),
        "value": fourthBonus.bonusValue !== null ? fourthBonus.bonusValue : "- ",
        "amount": fourthBonus.maximumBonusAmount !== null ? fourthBonus.maximumBonusAmount : "- ",
        "maxBonusCashout": fourthBonus.maxBonusCashout ? fourthBonus.maxBonusCashout: "",
        "freeSpin": fourthBonus.freespinsAmount !== null ? fourthBonus.freespinsAmount : "-"
      } : null,
      fifthBonus !== null ? {
        "label": t.get(translations, "Fifth deposit"),
        "value": fifthBonus.bonusValue !== null ? fifthBonus.bonusValue : "- ",
        "amount": fifthBonus.maximumBonusAmount !== null ? fifthBonus.maximumBonusAmount : "- ",
        "maxBonusCashout": fifthBonus.maxBonusCashout ? fifthBonus.maxBonusCashout: "",
        "freeSpin": fifthBonus.freespinsAmount !== null ? fifthBonus.freespinsAmount : "-"
      } : null,
      sixthBonus !== null ? {
        "label": t.get(translations, "Sixth deposit"),
        "value": sixthBonus.bonusValue !== null ? sixthBonus.bonusValue : "- ",
        "amount": sixthBonus.maximumBonusAmount !== null ? sixthBonus.maximumBonusAmount : "- ",
        "maxBonusCashout": sixthBonus.maxBonusCashout ? sixthBonus.maxBonusCashout: "",
        "freeSpin": sixthBonus.freespinsAmount !== null ? sixthBonus.freespinsAmount : "-"
      } : null
    ]

    return <ul className={`${styles.depositBonusList}`}>
      <p>{t.get(translations, "Bonus structure")}</p>
      {bonusArray.map((x, index) => (
        x !== null &&
        <li><ArrowRightIcon /><label>{x.label}: </label>
          <div>
            <p><label>{t.get(translations, "bonus")}:</label><span> {x.value}%</span><span> / {x.amount}{t.get(translations, 'currency')}</span></p><span className={`gamble-hidden-sm-up ${styles.seperator}`}>|</span>
            <p>
              <label>{t.get(translations, "expand-freespins")}:</label>{x.freeSpin !== null ? <span> {x.freeSpin}</span> : <span> - </span>}
            </p>
            { x.maxBonusCashout ? (
              <p>
                <label>{t.get(translations, "expand-max-cashout")}:</label>{x.maxBonusCashout !== null ? <span> {x.maxBonusCashout}</span> : <span> - </span>}
              </p>
            ) : null }
            </div>
        </li>
      ))}
    </ul>
  };

  const benefitsList = (casino) => {

    let wt = casino !== null ? casino.withdrawalTimes : null;
    let firstBonus = CasinoHelper.GetFirstDepositBonus(casino) !== null ? CasinoHelper.GetFirstDepositBonus(casino).minimumDeposit : null;

    return <ul className={`${styles.benefitsList}`}>
      {wt !== null ?
        <li><ArrowRightIcon /><label>{t.get(translations, "Withdrawal times")}:</label><span> {wt} {t.get(translations, "days")}</span></li> :
        <li><ArrowRightIcon /><label>{t.get(translations, "Withdrawal times")}:</label><span> -</span></li>
      }
      {firstBonus !== null ?
        <li><ArrowRightIcon /><label>{t.get(translations, "Minimum deposit")}:</label><span> {firstBonus}{t.get(translations, 'currency')}</span></li> :
        <li><ArrowRightIcon /><label>{t.get(translations, "Minimum deposit")}:</label><span> -</span></li>
      }

      <li><ArrowRightIcon /><label>{t.get(translations, "Wagering Requirement")}: </label>
      {(bonus && bonus.wageringRequirement && bonus.wageringRequirementType) ?
        <span>{bonus.wageringRequirement}{t.get(translations, bonus.wageringRequirementType)}</span> : '-'}
      </li>
      <li><ArrowRightIcon /><label>{t.get(translations, "max-bet")}: </label>
      {(casino && casino.maxBet) ?
          <span>{getMaxBetText(translations, casino.maxBet)}</span> : '-'}
      </li>
    </ul>
  };

  const bonus = getBonusToUse(casino, forceSports, forceSpecificBonusType, showBonusCode)
  let freespinNoDepositBonus = CasinoHelper.GetFreespinNoDepositBonus(casino)

  let isFreespins = false;
  if (forceSpecificBonusType && CasinoHelper.IsFreespinNoDepositBonus(forceSpecificBonusType))
    isFreespins = true;

    const getBonusHighlight = (bonus, casino) => {
      if (casino && casino.promotionOverride) {
        return <div className={`${styles.promotionOverrideParent}`}>
          <div className={`${styles.promotionOverride}`}>{casino.promotionOverride}
            <span></span>
            <span></span>
          </div>
        </div>

      }

      if (casino && casino.promotionOverride){
        return <div className={`${styles.promoOverrideParent}`}>
          <div className={`${styles.promoOverrideRibbon}`}>{casino.promotionOverride}
            <span></span>
            <span></span>
          </div>
        </div>
      }

      if (casino && promotionalText && promotionalText(casino))
        return [
          casino.hasNoAccount && locale === "fi" ? <div className={`${styles.noAccountRibbonParent}`}>
            <div className={`${styles.noAccountRibbon}`}>Pay N Play
              <span></span>
              <span></span>
            </div>
          </div> : '',
          <div className={`${styles.exclusiveRibbonParent}`}>
            <div className={`${styles.exclusiveRibbon}`}>{promotionalText(casino)}
              <span></span>
              <span></span>
            </div>
          </div>]

      if (casino && isRaffle && casino.raffleInformation)
        return [
          casino.hasNoAccount && locale === "fi" ? <div className={`${styles.noAccountRibbonParent}`}>
            <div className={`${styles.noAccountRibbon}`}>Pay N Play
              <span></span>
              <span></span>
            </div>
          </div> : '',
          <div className={`${styles.exclusiveRibbonParent}`}>
          <div className={`${styles.exclusiveRibbon}`}>{casino.raffleInformation}
            <span></span>
            <span></span>
          </div>
        </div>]

      if (bonus && bonus.isExclusive && !isRaffle)
        return <div className={`${styles.exclusiveRibbonParent}`}>
          <div className={`${styles.exclusiveRibbon}`}>{t.get(translations, 'exclusive-banner')}
            <span></span>
            <span></span>
          </div>
        </div>

      if (casino.hasNoAccount && locale === "fi")
        return <div className={`${styles.noAccountRibbonParent}`}>
          <div className={`${styles.noAccountRibbon}`}>Pay N Play
                <span></span>
            <span></span>
          </div>
        </div>

    }

  return (
    <div className={`${styles.cardContainer}`} key={casino.name}>
      {locale === "enGB" &&
        <p className={`gamble-hidden-sm-down ${styles.warnings}`}>
          <span>gamble responsibly | </span>
          <a target={`_blank`} rel={`noopener noreferrer nofollow`} href="http://gambleaware.org/">Gambleaware.org</a>
          <span> | +18</span>
        </p>
      }
      <Grid container spacing={0} className={`${styles.card}`}>
        <Grid
          item
          xs={10}
          sm={11}
          lg={11}
          container
          spacing={0}
          alignItems="center"
          className={`${styles.casinoContent} ${locale === "enGB" && styles.responsibleGaming}`}
        >
          <Grid container spacing={0}>
            <Grid item xs={12} sm={5} md={5} className={`${styles.casinoTitle}`}>
              <span className={`casino-ranking`}>{index}</span>

              {casino.extendedData && casino.extendedData.closed === true ?
                <Link to={r.get(locale, translations, "casinoReview", casino.name)}>
                  {casino.smallLogo && (
                    <Img
                      fluid={casino.smallLogo && casino.smallLogo.asset && casino.smallLogo.asset.fluid}
                      className={`${styles.cardImage} ${styles.casinoClosed}`}
                      alt={`${casino.name}-logo`}
                    />
                  )}
                  {!casino.smallLogo && (
                    <p className={`${styles.cardImage}`}>{casino.name}</p>
                  )}
                </Link>
                :
                <a
                  target={`_blank`} rel={`noopener noreferrer nofollow`} aria-label={t.get(translations, "play-now")} href={r.get(locale, translations, "redirectPage", casino.affiliateMask)}>
                  {casino.smallLogo && (
                    <Img
                      fluid={casino.smallLogo && casino.smallLogo.asset && casino.smallLogo.asset.fluid}
                      className={`${styles.cardImage}`}
                      alt={`${casino.name}-logo`}
                    />
                  )}
                  {!casino.smallLogo && (
                    <p className={`${styles.cardImage}`}>{casino.name}</p>
                  )}
                </a>
              }

              <div>
                <p className={` ${styles.header}`}>{casino.name}</p>
                {locale === "enGB" && <p className="gamble-hidden-sm-down">
                  <a
                    target={`_blank`}
                    rel={`noopener noreferrer nofollow`}
                    href={casino.casinoTermsLink ? casino.casinoTermsLink : r.get(locale, translations, "redirectPage", casino.affiliateMask)}
                  >
                    {`${t.get(translations, "terms-and-conditions")} apply - New customers only`}
                  </a>
                </p>}
              </div>
              <div onClick={handleDesktopExpandClick} className={`gamble-hidden-sm-up ${styles.mobileWelcomeBonus}`}>
                {bonus && bonus.bonusValue && !isFreespins && (
                  <p>
                    {bonus.type && bonus.type.name}: <span>{bonus.bonusValue}% / {bonus.cashbackIsPerSpin ? t.get(translations, 'per-spin')  : bonus.maximumBonusAmount + t.get(translations, 'currency')} </span>
                  </p>
                )}
                {bonus && CasinoHelper.IsNoDepositBonus(forceSpecificBonusType) && bonus.maximumBonusAmount &&
                  <p>
                    {bonus.type && bonus.type.name}: <span> {bonus.maximumBonusAmount} {t.get(translations, 'currency')} </span>
                  </p>
                }
                {isFreespins && (
                  <p>
                    {t.get(translations, "freespins-no-deposit")} : <span>{bonus.freespinsAmount}</span>
                  </p>
                )}
                {desktopExpanded ?
                  <ExpandLessIcon onClick={handleDesktopExpandClick} className={`${styles.bonusCardPlusSign}`} aria-label={t.get(translations, "open casino details")} /> :
                  <ExpandMoreIcon onClick={handleDesktopExpandClick} className={`${styles.bonusCardPlusSign}`} aria-label={t.get(translations, "close casino details")} />
                }
              </div>
            </Grid>
            {casino.extendedData && casino.extendedData.closed === true &&
              <Grid item xs={7} sm={7} md={7} className={`${styles.casinoClosedText}`}>
                <span>
                  <BlockIcon />
                  {t.get(translations, 'casino-closed')}!
                </span>
              </Grid>
            }
            <Grid item xs={4} sm={3} md={3} className={`gamble-hidden-sm-down ${styles.welcomeOffer}`}>
              {bonus && bonus.bonusValue && !isFreespins && (
                <p className={` ${styles.header}`}>
                  {bonus.bonusValue}% / {bonus.cashbackIsPerSpin ? t.get(translations, 'per-spin')  : bonus.maximumBonusAmount + t.get(translations, 'currency')}
                </p>
              )}

              {
                bonus && CasinoHelper.IsNoDepositBonus(forceSpecificBonusType) && bonus.maximumBonusAmount &&
                <p className={` ${styles.header}`}>
                  {bonus.maximumBonusAmount} {t.get(translations, 'currency')}
                </p>
              }
              {isFreespins && !bonus.bonusValue && firstDepositBonus && firstDepositBonus.bonusValue &&
              (
                <p className={` ${styles.header}`}>
                  {firstDepositBonus.bonusValue}% / {firstDepositBonus.maximumBonusAmount}{t.get(translations, 'currency')}
                </p>
              )
              }

              {bonus && bonus.freespinsAmount &&
                (
                  <p className= {`${styles.freeSpinAmount}`}>
                    +{" "} {bonus.freespinsAmount}{" "}
                      {t.get(translations, "fd-freespins")}
                  </p>
                )
              }
              {bonus && bonus.type && <p> {bonus.type.name} </p>}
              {!bonus && "-"}
            </Grid>
              <Grid item xs={6} sm={2} md={2} className={`gamble-hidden-sm-down ${styles.freeSpin}`}>
              {!forceSports
                ? (
                  bonus && bonus.bonusCode ? getBonusCodeLine(translations, bonus) :
                  freespinNoDepositBonus ? getFreespinsNoDepositLine(translations, freespinNoDepositBonus) :
                  getMrGambleRatingLine(translations, casino)
                )
                : null}
              {forceSports
                ? getSportsbookMinimumOddLine(translations, bonus)
                : null}
            </Grid>
            <Grid item xs={6} sm={2} md={2} className={`gamble-hidden-sm-down ${styles.recycling}`}>
              <p className={` ${styles.header}`}>
                {bonus && bonus.wageringRequirement}
                {(bonus && bonus.wageringRequirementType) ? t.get(translations, bonus.wageringRequirementType) : '-'}
              </p>
              <p>{t.get(translations, "Wagering Requirement")}</p>
              {desktopExpanded ?
                <ExpandLessIcon onClick={handleDesktopExpandClick} className={`${styles.bonusCardPlusSign}`} aria-label={t.get(translations, "open casino details")} /> :
                <ExpandMoreIcon onClick={handleDesktopExpandClick} className={`${styles.bonusCardPlusSign}`} aria-label={t.get(translations, "close casino details")} />
              }
            </Grid>
            { getBonusHighlight(bonus, casino) }
            <Collapse in={desktopExpanded} timeout={400} className={`${styles.desktopCollapseContent}`}>
              <div className={`${styles.container}`}>
                {
                   bonus && bonus.bonusCode ? (
                      <ul className={`${styles.mobileDetails} gamble-hidden-sm-up`}>
                        <p>{t.get(translations, "bonus-code")}</p>
                        <li><ArrowRightIcon />
                          <span> {bonus ? bonus.bonusCode : "-"}</span>
                        </li>
                      </ul>
                    ) : null
                }
                { freespinNoDepositBonus ? (
                  <ul className={`${styles.mobileDetails}`}>
                    <p>{t.get(translations, "freespins-no-deposit")}</p>
                    <li><ArrowRightIcon />
                    <label>
                      {t.get(translations, "expand-freespins")}:
                    </label>
                      <span> {freespinNoDepositBonus ? freespinNoDepositBonus.freespinsAmount : "-"}</span>
                    </li>
                  </ul>
                ) : null }
                {casino && bonusList(casino)}
                {casino && benefitsList(casino)}
                <div className={`${styles.expandButtons}`}>
                  <Link to={r.get(locale, translations, "casinoReview", casino.name)}>
                    <Button variant="contained" color="secondary">
                      {buttonName || t.get(translations, "Casino-Review")}
                    </Button>
                  </Link>
                  {casino.extendedData && casino.extendedData.closed === true ?
                    ""
                  :
                    <a
                      target={`_blank`} rel={`noopener noreferrer nofollow`}
                      href={r.get(locale, translations, "redirectPage", casino.affiliateMask)} >
                      <Button variant="contained" color="primary">
                        {t.get(translations, "play-now")}
                      </Button>
                    </a>
                  }
                </div>
              </div>
            </Collapse>
          </Grid>
        </Grid>
        <Grid item xs={2} sm={1} lg={1} className={`${styles.casinoPlay}`}>
          <Grid
            container
            spacing={0}
            alignItems="center"
            className={`${styles.casinoPlayContainer} ${casino.extendedData && casino.extendedData.closed === true ? styles.casinoClosed : ""}`}
          >
            <Grid item lg={12}>
              {casino.extendedData && casino.extendedData.closed === true ?
                <Link to={r.get(locale, translations, "casinoReview", casino.name)}>
                  <PlayArrowIcon />
                </Link>
                :
                <a
                  target={`_blank`} aria-label={t.get(translations, "play-now")} rel={`noopener noreferrer nofollow`}
                  href={r.get(locale, translations, "redirectPage", casino.affiliateMask)} >
                  <PlayArrowIcon />
                </a>
              }
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {locale === "enGB" &&
        <p className={`gamble-hidden-sm-up ${styles.warnings}`}>
          <span>gamble responsibly | </span>
          <a target={`_blank`} rel={`noopener noreferrer nofollow`} href="http://gambleaware.org/">Gambleaware.org</a>
          <span> | +18</span> <span id={'terms'}> <a id={'termslink'}
              target={`_blank`}
              rel={`noopener noreferrer nofollow`}
              href={casino.casinoTermsLink ? casino.casinoTermsLink : r.get(locale, translations, "redirectPage", casino.affiliateMask)}
            >
            | {`${t.get(translations, "terms-and-conditions")} apply - New customers only`}
            </a>
          </span>
        </p>
      }
    </div>
  )
}

export default LineBonusCard
